export const FILTER_CLOSE_MODAL = 'FILTER__CLOSE_MODAL';
export const FILTER_LIST_ITEM_COUNT = 'FILTER_LIST__ITEM_COUNT';
export const FILTER_LIST_CLOSE_BUTTON = 'FILTER_LIST__CLOSE_BUTTON';

export const DRILLDOWN_VIEW_FILTER_BUTTON = 'DRILLDOWN_FILTER__VIEW_FILTER_BUTTON';
export const DRILLDOWN_BACK_BUTTON = 'DRILLDOWN_FILTER__BACK_BUTTON';
export const DRILLDOWN_CLOSE_BUTTON = 'DRILLDOWN_FILTER__CLOSE_BUTTON';
export const DRILLDOWN_RESET_BUTTON = 'DRILLDOWN_FILTER__RESET_BUTTON';
export const DRILLDOWN_VIEW_RESULTS_BUTTON = 'DRILLDOWN_FILTER__VIEW_RESULTS_BUTTON';
export const DRILLDOWN_LIST_ITEM_COUNT = 'DRILLDOWN_FILTER__FILTER_LIST_ITEM_COUNT';
export const DRILLDOWN_HEADING_MAIN = 'DRILLDOWN_FILTER__HEADING_MAIN';
export const DRILLDOWN_HEADING_SELECTED = 'DRILLDOWN_FILTER__HEADING_SELECTED';

export const FILTER_CONTROLS_RESET_BUTTON = 'FILTER_CONTROLS__RESET_BUTTON';
export const FILTER_CONTROLS_VIEW_RESULTS_BUTTON = 'FILTER_CONTROLS__VIEW_RESULTS_BUTTON';
